/**
 * Replaces comma with period, To be used with input[type="text"]
 * @name replaceCommaWithPeriod
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('replaceCommaWithPeriod', replaceCommaWithPeriod);

    function replaceCommaWithPeriod() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(value) {
                    if (!value) return value;

                    const replacedValue = value.replace(/,/g, '.');

                    ngModel.$setViewValue(replacedValue);
                    ngModel.$render();

                    return replacedValue;
                });
            }
        };
    }
})();
